import { render } from "./Jokyo.vue?vue&type=template&id=48cd1d02&scoped=true"
import script from "./Jokyo.vue?vue&type=script&lang=js"
export * from "./Jokyo.vue?vue&type=script&lang=js"

import "./Jokyo.vue?vue&type=style&index=0&id=48cd1d02&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cd1d02"]])

export default __exports__